<template>
    <div class="file-dropzone"
         :class="{ hovering, disabled }"
         @dragover.prevent="onDragOver"
         @dragenter="onDragEnter"
         @dragleave="onDragLeave"
         @drop="onDrop">
        <div class="file-dropzone-overlay">
            <div class="file-dropzone-overlay-label"
                 :style="labelStyle">
                Släpp filerna här
            </div>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FileDropzone',
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                hovering: false,
                dragCounter: 0,
                labelOffset: 0
            };
        },
        computed: {
            labelStyle() {
                return {
                    top: `${this.labelOffset}px`
                };
            }
        },
        beforeDestroy() {
            this.stopViewportTracking();
        },
        methods: {
            onDragOver(e) {
                if (this.disabled) {
                    return;
                }

                e.preventDefault();
                this.updateLabelPosition();
            },
            onDragEnter(e) {
                if (this.disabled) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();
                this.dragCounter += 1;
                this.hovering = true;
                this.updateLabelPosition();
                this.startViewportTracking();
            },
            onDragLeave(e) {
                if (this.disabled) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();
                this.dragCounter -= 1;

                if (this.dragCounter <= 0) {
                    this.dragCounter = 0;
                    this.hovering = false;
                    this.stopViewportTracking();
                }
            },
            onDrop(e) {
                e.preventDefault();
                e.stopPropagation();
                this.hovering = false;
                this.dragCounter = 0;
                this.stopViewportTracking();

                if (this.disabled) {
                    return;
                }

                this.$emit('drop', e.dataTransfer && e.dataTransfer.files);
            },
            updateLabelPosition() {
                const el = this.$el;
                if (!el || typeof el.getBoundingClientRect !== 'function') {
                    return;
                }

                const rect = el.getBoundingClientRect();
                const visibleTop = Math.max(rect.top, 0);
                const visibleBottom = Math.min(rect.bottom, window.innerHeight);

                if (visibleBottom <= visibleTop) {
                    return;
                }

                this.labelOffset = ((visibleTop + visibleBottom) / 2) - rect.top;
            },
            startViewportTracking() {
                this.stopViewportTracking();
                window.addEventListener('scroll', this.updateLabelPosition, true);
                window.addEventListener('resize', this.updateLabelPosition);
            },
            stopViewportTracking() {
                window.removeEventListener('scroll', this.updateLabelPosition, true);
                window.removeEventListener('resize', this.updateLabelPosition);
            }
        }
    };
</script>

<style scoped>
    .file-dropzone {
        position: relative;
        min-height: 40vh;
    }

    .file-dropzone-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #dee2e6e0;
        pointer-events: none;
        z-index: 20;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .file-dropzone-overlay-label {
        position: absolute;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        text-align: center;
        font-size: 2rem;
        color: #000;
        padding: 0.5rem 1rem;
        pointer-events: none;
    }

    .file-dropzone.hovering .file-dropzone-overlay {
        opacity: 1;
    }
</style>
